import React from 'react';
import cap1 from "../assets/bahce.webp";
import cap2 from "../assets/cambalkon.webp";
import cap3 from "../assets/15.webp";
import cap4 from "../assets/dusakabin.webp";
import "../assets/slide.css";

const Carousel = () => {
  return (
    <div className='sliderow'>
      <figure className="snip0016">
        <img src={cap3} alt="sample42" className='imgg' />
        <figcaption>
          <h2>MURAT &nbsp; BEY</h2>
          <p>Panjur sistemimizi bu firmadan yaptırdık ve her şeyden çok memnun kaldık. Ürünlerin kalitesi gayet iyi ve gerçekten uzun süre dayanacağını düşünüyoruz. Ayrıca, tüm süreç boyunca iletişimdeki açıklık ve yardımlarından dolayı teşekkür ederim. Herhangi bir aksaklık yaşamadık ve zamanında teslimat sağlandı.</p>
          <a href="#"></a>
        </figcaption>
      </figure>

      <figure className="snip0016">
        <img src={cap4} alt="sample43" className='imgg' />
        <figcaption>
          <h2>ELİF &nbsp; HANIM</h2>
          <p>Duş kabini ve cam balkon yaptırmak için tercih ettiğimiz bu firma, her aşamada bizi bilgilendirdi ve taleplerimizi dikkate aldı. Ürünlerin kalitesi gerçekten çok güzel, hem modern hem de sağlam. Montaj ekibi oldukça dikkatli ve titizdi. Sonuçtan gerçekten memnun kaldık, kesinlikle tavsiye ederim.</p>
          <a href="#"></a>
        </figcaption>
      </figure>

      <figure className="snip0016">
        <img src={cap1} alt="sample42" className='imgg' />
        <figcaption>
          <h2>AHMET &nbsp; BEY</h2>
          <p>Yeni evim için pencere ve panjur sistemlerini değiştirmeye karar verdim. Firma, beklentilerimi karşılamak adına hızlı bir şekilde geri dönüş yaptı ve tüm süreç boyunca yardımcı oldular. Montaj işlemi düzgün bir şekilde yapıldı ve ürünler gerçekten kaliteli. Zamanında teslimat sağlandı, memnun kaldım.</p>
          <a href="#"></a>
        </figcaption>
      </figure>

      <figure className="snip0016">
        <img src={cap2} alt="sample43" className='imgg' />
        <figcaption>
          <h2>ALİ &nbsp; BEY</h2>
          <p>Yeni evimiz için pencere ve cam kapı çözümleri arıyorduk. Bu firmadan aldığımız hizmetten çok memnun kaldık. Hem ürünler hem de hizmet kalitesi çok iyi. Montaj süreci hızlı ve düzgün şekilde tamamlandı, her şey tam istediğimiz gibi oldu. Uzun vadede de memnun kalacağımızı düşünüyoruz.</p>
          <a href="#"></a>
        </figcaption>
      </figure>
    </div>
  );
};

export default Carousel;